import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { NODE_ENV, PUBLIC_URL } from "@/lib/env";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if (NODE_ENV !== "production") {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().catch(() => {});
      });
    }).catch(() => {});
  }
  if ("caches" in window) {
    caches.keys().then((keys) => {
      keys
        .filter((key) => key.startsWith("rsi-") || key.startsWith("workbox"))
        .forEach((key) => {
          caches.delete(key).catch(() => {});
        });
    }).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
const appTree = (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

root.render(
  NODE_ENV === "production" ? <React.StrictMode>{appTree}</React.StrictMode> : appTree
);

// Register service worker for PWA
if ("serviceWorker" in navigator && NODE_ENV === "production") {
  window.addEventListener("load", () => {
    const swUrl = `${PUBLIC_URL}/sw.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {});
  });
}
